import React from 'react';
import { getLinkFromState } from '../helpers/rickTextEditor.helpers';
import StyleButton from '../styleButton';
var LinkControl = function LinkControl(_ref) {
  var control = _ref.control,
    editorState = _ref.editorState,
    onToggle = _ref.onToggle;
  var link = getLinkFromState(editorState);
  return /*#__PURE__*/React.createElement(StyleButton, {
    key: control.label,
    active: !!link,
    label: control.label,
    onToggle: onToggle,
    style: control.style,
    icon: control.icon
  });
};
export default LinkControl;